<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <v-card v-if="polygon !== undefined">
      <v-card-title class="mb-2">Edit polygon</v-card-title>
      <v-card-text class="pt-1">
        <v-row>
          <v-col cols="12" sm="6">
            <color-picker v-model="polygon.color" />
          </v-col>
          <v-col cols="12" sm="6">
            <color-picker v-model="polygon.hover_color" />
          </v-col>
          <v-col cols="12" :sm="polygon.on_click.action === '' ? 12 : 4">
            <v-select
              :items="[
                { name: 'No action', action: '' },
                { name: 'Open URL', action: 'go_url' },
                { name: 'Open scene', action: 'go_scene' }
              ]"
              :disabled="loading"
              v-model="polygon.on_click.action"
              label="On click event"
              item-text="name"
              item-value="action"
            ></v-select>
          </v-col>
          <v-col v-if="polygon.on_click.action === 'go_scene'" cols="12" sm="8">
            <v-select
              :items="scenes"
              :disabled="loading"
              v-model="polygon.on_click.value"
              label="Open scene"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-col>
          <v-col v-if="polygon.on_click.action === 'go_url'" cols="12" sm="8">
            <v-text-field
              :disabled="loading"
              v-model="polygon.on_click.value"
              label="URL"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="red darken-1"
          text
          @click="remove">Remove</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="darken-1"
          text
          @click="cancel">Cancel</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ColorPicker from '@/components/ColorPicker'
export default {
  name: 'PolygonDialog',
  components: { ColorPicker },
  props: {
    scenes: Array
  },
  data: () => ({
    loading: false,
    polygon: undefined,
    dialog: false,
    resolve: null,
    reject: null
  }),
  methods: {
    open (pg) {
      this.dialog = true
      const polygon = { ...pg }

      if (polygon.color === undefined || polygon.color === '') {
        polygon.color = '#007EFFFF'
      }
      if (polygon.hover_color === undefined || polygon.hover_color === '') {
        polygon.hover_color = '#007EFFFF'
      }
      if (polygon.on_click === null) {
        polygon.on_click = {
          action: '',
          value: ''
        }
      }
      this.polygon = polygon
      this.$forceUpdate()

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    save () {
      this.resolve(this.polygon)
      this.dialog = false
    },
    cancel () {
      this.resolve('cancel')
      this.dialog = false
    },
    remove () {
      this.resolve('remove')
      this.dialog = false
    }
  }
}
</script>

<style scoped lang="scss">

</style>
